import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

import { ZB_SESSION_CLAIMS_COOKIE } from '#client/constants/tokens';

/**
 * Converts a timestamp in seconds to milliseconds.
 *
 * @param {number} iat - The timestamp representing the issue date in seconds.
 * @returns {number} The converted timestamp in milliseconds, or 0 if the input is falsy.
 */
export const getIssuedAt = (iat) => {
  if (iat) {
    return iat * 1000;
  }
  return 0;
};

/**
 * Extracts a specific value from the decoded access token using the provided key name.
 * First checks for the value in the JWT claims cookie, to support the new session management
 * solution.
 *
 * @param {string} accessToken - The access token to decode and extract the value from.
 * @param {string} keyName - The key name of the value to extract from the token.
 * @returns {any} The extracted value from the decoded token,
 * or undefined if the token or value is not present.
 * @throws {Error} Throws an error if there is an issue decoding the token.
 */
export const extractTokenValue = (accessToken, keyName) => {
  // First check for the ZB session claims cookie
  const zbClaimsCookie = Cookies.get(ZB_SESSION_CLAIMS_COOKIE);
  if (zbClaimsCookie) {
    const parsedCookie = JSON.parse(decodeURIComponent(zbClaimsCookie));
    if (parsedCookie) {
      const cookieValue = parsedCookie[keyName];
      if (cookieValue) {
        return cookieValue;
      }
    }
  }

  try {
    if (!accessToken) {
      return undefined;
    }

    const decodedToken = jwtDecode(accessToken);
    return decodedToken ? decodedToken[keyName] : undefined;
  } catch (error) {
    throw new Error(`Error decoding token with key: ${keyName}`, error);
  }
};
